// ! Переменная замок, предотвращает двойные нажатия на интерактивные кнопки (открытие modal например)
const unlock = true;

const modalTriggers = [...document.querySelectorAll(".js-modal-trigger")];

for (const trigger of modalTriggers) {
    trigger.addEventListener("click", (e) => {
        if (unlock) {
            const modalName = trigger.getAttribute("data-modal-target");

            if (modalName) {
                modalOpen(modalName);
            }
        }

        e.preventDefault();
    });
}

function modalOpen(item) {
    const currentmodal = document.querySelector(`[data-modal="${item}"]`);

    if (currentmodal && unlock) {
        currentmodal.classList.add("active-modal");

        document.body.classList.add("scroll-lock");
    }
}

const modals = [...document.querySelectorAll(".js-modal")];

for (const modal of modals) {
    // закрытие попапа при клике на темную область
    modal.addEventListener("click", (e) => {
        if (!e.target.closest(".modal__content")) {
            modalСlose(e.target.closest(".modal"));
        }
    });
}

const modalCloseIcons = [...document.querySelectorAll(".modal__close")];

for (const closeIcon of modalCloseIcons) {
    closeIcon.addEventListener("click", () => {
        modalСlose(closeIcon.closest(".modal"));
    });
}

document.addEventListener("keydown", (e) => {
    if (e.code === "Escape") {
        modalСlose();
    }
});

function modalСlose(item) {
    if (unlock) {
        if (!item) {
            for (const modal of modals) {
                modal.classList.remove("active-modal");
            }
        } else {
            item.classList.remove("active-modal");
        }

        const activemodals = document.querySelectorAll(".active-modal");

        if (!activemodals.length) {
            document.body.classList.remove("scroll-lock");
        }
    }
}
